import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import FunFact1 from "./funfacts/FunFact1";
import FunFact2 from "./funfacts/FunFact2";
import FunFact3 from "./funfacts/FunFact3";
import FunFact4 from "./funfacts/FunFact4";
import CourseScreen from "./CourseScreen";
import Question1 from "./questions/Question1";
import Question2 from "./questions/Question2";
import Question3 from "./questions/Question3";
import Question4 from "./questions/Question4";
import Question5 from "./questions/Question5";
import Question6 from "./questions/Question6";
import Question7 from "./questions/Question7";
import Question8 from "./questions/Question8";
import Question9 from "./questions/Question9";
import Question10 from "./questions/Question10";
import Question11 from "./questions/Question11";
import Question12 from "./questions/Question12";
import Question13 from "./questions/Question13";
import "./QuizScreen.css";

function QuizScreen() {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [userResponses, setUserResponses] = useState({});
  const [isFunFactVisible, setIsFunFactVisible] = useState(false);
  const [isQuizCompleted, setIsQuizCompleted] = useState(false);

  const questionComponents = [
    Question1,
    Question2,
    Question3,
    Question4,
    Question5,
    Question6,
    Question7,
    Question8,
    Question9,
    Question10,
    Question11,
    Question12,
    Question13,
  ];

  const funFactComponents = [FunFact1, FunFact2, FunFact3, FunFact4];
  const CurrentQuestionComponent = questionComponents[currentQuestionIndex];
  const CurrentFunFactComponent =
    funFactComponents[Math.floor(currentQuestionIndex / 3)];

  const handleNextQuestion = () => {
    if (
      (currentQuestionIndex + 1) % 3 === 0 &&
      currentQuestionIndex + 1 < questionComponents.length
    ) {
      setIsFunFactVisible(true);
    } else if (currentQuestionIndex + 1 < questionComponents.length) {
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
    } else {
      setIsQuizCompleted(true);
    }
  };

  const handleAnswer = (questionTitle, response) => {
    setUserResponses((prevResponses) => ({
      ...prevResponses,
      [questionTitle]: response,
    }));
  };

  const handleFunFactNext = () => {
    setIsFunFactVisible(false);
    setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
  };

  return (
    <div className="quiz-screen">
      {isQuizCompleted ? (
        <CourseScreen responses={userResponses} />
      ) : isFunFactVisible ? (
        <CurrentFunFactComponent onNext={handleFunFactNext} />
      ) : (
        <AnimatePresence mode="wait">
          <motion.div
            key={currentQuestionIndex}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.5 }}
          >
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleNextQuestion();
              }}
            >
              <div className="motion-wrapper">
                <CurrentQuestionComponent
                  onAnswer={handleAnswer}
                  userResponse={userResponses}
                />
              </div>
            </form>
          </motion.div>
        </AnimatePresence>
      )}
    </div>
  );
}

export default QuizScreen;
